// PlayerSelectModal (jQuery, minimal-change version)
// 既存の部分テンプレート(shared/_players_select_modal.html.haml)を前提に、
// 表示/非表示、選択数制御、ローディング表示、イベント束ねを提供する。
// グローバル(window)にクラスを公開し、既存のbundle順序にも耐える。
;(function () {
  if (window.PlayerSelectModal) return;

  // プレイヤー選択人数の制限値を取得する
  function getLimitFromDom($modal) {
    const dataLimit = Number($modal.data('limit'));
    if (!Number.isNaN(dataLimit) && dataLimit > 0) return dataLimit;
    // limitがdata-limitにない場合は、p.player-select-modal__limitのテキストを取得する
    const txt = $modal.find('p.player-select-modal__limit').text() || '';
    const m = txt.match(/\d+/);
    return m ? Number(m[0]) : 0;
  }

  class PlayerSelectModal {
    constructor(opts = {}) {
      const {
        modalSelector = '#players-select-modal',
        confirmSelector = '#players-select-confirm-btn',
        cancelSelector = '#players-select-cancel-btn',
      } = opts;
      this.$modal = $(modalSelector);
      this.$panel = this.$modal.find('.player-select-modal');
      this.$confirm = this.$modal.find(confirmSelector);
      this.$cancel = this.$modal.find(cancelSelector);
      this.onConfirm = null;
      this.limit = 0;
      this._bound = false;
      // selectionMode: 'exact'（既定・従来挙動＝ちょうどlimit件強制） / 'free'（minSelected件以上なら確定可）
      this.selectionMode = 'exact';
      this.minSelected = 1;
      this.loadingOnConfirm = true;
    }

    open({ items, limit, title, onConfirm, selectionMode = 'exact', checkedIds = [], minSelected = 1, loadingOnConfirm = true } = {}) {
      if (this.$modal.length === 0) return;
      // itemsが渡された場合のみ一覧を再構築（テンプレートを複製）
      if (Array.isArray(items)) {
        const $list = this.$modal.find('.modal-player-list');
        const $tmpl = this.$modal.find('.modal-player-template label');
        $list.empty();
        items.forEach((it) => {
          const $row = $tmpl.clone();
          $row.attr('data-player-name', it.name);
          $row.find('input[type="checkbox"]').addClass('checkbox players-select-checkbox').val(it.id);
          $row.find('span').text(it.name);
          $list.append($row);
        });
      }
      // タイトル（任意）
      if (title) {
        this.$modal.find('#players-select-modal-title').text(title);
      }
      // 制限値の決定（引数優先 → data-limit → 文言解析）
      this.limit = Number(limit || getLimitFromDom(this.$modal)) || 0;
      this.$modal.attr('data-limit', this.limit);
      this.selectionMode = selectionMode === 'free' ? 'free' : 'exact';
      this.minSelected = Number(minSelected) || 1;
      this.loadingOnConfirm = loadingOnConfirm !== false;

      // 初期状態：チェックオフ、活性化、ボタン初期化
      this.$modal.find('.players-select-checkbox').prop('checked', false).prop('disabled', false);
      // checkedIdsに含まれるものだけ初期チェック（'free'モードの初期選択復元用）
      if (Array.isArray(checkedIds) && checkedIds.length > 0) {
        const idSet = new Set(checkedIds.map(Number));
        this.$modal.find('.players-select-checkbox').each(function () {
          if (idSet.has(Number($(this).val()))) {
            $(this).prop('checked', true);
          }
        });
      }
      this.$confirm.prop('disabled', true).removeClass('loading inactive').text(this.$confirm.data('orig-text') || this.$confirm.text());
      this.$confirm.css({ width: '', height: '' });
      $('body').css('pointer-events', '');

      this.onConfirm = typeof onConfirm === 'function' ? onConfirm : null;
      this._bindEventsOnce();
      this._updateConfirmState();
      // 検索絞り込みの表示状態をリセット（前回開いたときの絞り込みを引き継がない）
      this.$modal.find('.js-psm-search').val('');
      this._applyPsmSearch('');

      // アニメーションで表示
      this.$modal.css('display', 'flex').addClass('starting');
      this.$panel.addClass('starting');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.$modal.removeClass('starting');
          this.$panel.removeClass('starting');
          // フォーカス移動（任意）
          const focusTarget = this.$panel.attr('tabindex') ? this.$panel : this.$confirm;
          focusTarget && focusTarget.focus && focusTarget.focus();
        });
      });
    }

    close() {
      const $panel = this.$panel;
      const $modal = this.$modal;
      $modal.addClass('starting');
      $panel.addClass('starting');
      let finished = false;
      const end = function () {
        if (finished) return;
        finished = true;
        $modal.off('transitionend', end);
        $modal.hide();
        $('body').css('pointer-events', '');
      };
      $modal.on('transitionend', end);
      setTimeout(end, 420);
      // キーハンドラは閉じ時に解除
      $(document).off('keydown.psm');
    }

    // プレイヤー選択モーダルで選択されたidを取得する
    getSelectedIds() {
      return this.$modal.find('.players-select-checkbox:checked').map(function () {
        return Number($(this).val());
      }).get();
    }

    // プレイヤー選択モーダルで選択されたnameを取得する
    getSelectedNames() {
      return this.$modal.find('.players-select-checkbox:checked').map(function () {
        return $(this).siblings('span').text();
      }).get();
    }

    _setLoading(isLoading) {
      if (isLoading) {
        const originalText = this.$confirm.data('orig-text') || this.$confirm.text();
        this.$confirm.data('orig-text', originalText);
        const fixedWidth = this.$confirm.outerWidth();
        const fixedHeight = this.$confirm.outerHeight();
        this.$confirm.css('width', fixedWidth);
        this.$confirm.css('height', fixedHeight);
        this.$confirm.prop('disabled', true).addClass('loading').text('');
        this.$cancel.prop('disabled', true);
        this.$modal.find('.players-select-checkbox').prop('disabled', true);
        $('body').css('pointer-events', 'none');
        this.$modal.css('pointer-events', 'auto');
      } else {
        this.$confirm.prop('disabled', false).removeClass('loading');
        this.$cancel.prop('disabled', false);
        this.$modal.find('.players-select-checkbox').prop('disabled', false);
        $('body').css('pointer-events', '');
      }
    }

    _updateConfirmState() {
      const checked = this.$modal.find('.players-select-checkbox:checked').length;
      // 'exact'（既定）: ちょうどlimit件のときだけ確定可（従来挙動を維持）
      // 'free': minSelected件以上なら確定可（上限はlimitのまま）
      const invalid = this.selectionMode === 'free' ? checked < this.minSelected : checked !== this.limit;
      if (invalid) {
        this.$confirm.prop('disabled', true).addClass('inactive');
      } else {
        this.$confirm.prop('disabled', false).removeClass('inactive');
      }
    }

    // 検索絞り込み: keywordに部分一致しない.modal-player-itemを隠す。0件なら.js-psm-emptyを表示する
    _applyPsmSearch(keyword) {
      const $empty = this.$modal.find('.js-psm-empty');
      if ($empty.length === 0) return;
      const lower = String(keyword || '').trim().toLowerCase();
      let visibleCount = 0;
      this.$modal.find('.modal-player-list .modal-player-item').each(function () {
        const name = String($(this).data('player-name') || '').toLowerCase();
        const matched = lower === '' || name.indexOf(lower) !== -1;
        $(this).toggle(matched);
        if (matched) visibleCount += 1;
      });
      $empty.toggleClass('d-none', visibleCount !== 0);
    }

    _bindEventsOnce() {
      if (this._bound) {
        // 念のため再バインド前に解除
        this.$modal.off('.psm');
        $(document).off('keydown.psm');
      }
      const self = this;
      // ラベルクリックでトグル（input直クリックは除外）
      this.$modal.on('click.psm', '.modal-player-item', function (e) {
        if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') return;
        e.preventDefault();
        const $cb = $(this).find('input[type="checkbox"]');
        if ($cb.length) {
          $cb.prop('checked', !$cb.prop('checked')).trigger('change');
          self._updateConfirmState();
        }
      });
      // チェック変更時にlimit超過を抑止（'exact'モードのみ。'free'は上限超過を許さない代わりに強制解除しない）
      this.$modal.on('change.psm', '.players-select-checkbox', function () {
        const checkedNow = self.$modal.find('.players-select-checkbox:checked').length;
        if (self.selectionMode === 'exact' && checkedNow > self.limit) {
          $(this).prop('checked', false);
        }
        self._updateConfirmState();
      });
      // 検索絞り込み（要素が存在する呼び出し元のみ有効）
      this.$modal.on('input.psm', '.js-psm-search', function () {
        self._applyPsmSearch($(this).val());
      });
      // 全選択/全解除（'free'モードのときのみ動作する）
      this.$modal.on('click.psm', '.js-psm-select-all', function () {
        if (self.selectionMode !== 'free') return;
        self.$modal.find('.modal-player-item:visible .players-select-checkbox').prop('checked', true);
        self._updateConfirmState();
      });
      this.$modal.on('click.psm', '.js-psm-deselect-all', function () {
        if (self.selectionMode !== 'free') return;
        self.$modal.find('.modal-player-item:visible .players-select-checkbox').prop('checked', false);
        self._updateConfirmState();
      });
      // ヘッダの閉じるボタン
      this.$cancel.off('click.psm').on('click.psm', function () {
        self.close();
      });
      // オーバーレイクリックで閉じる
      this.$modal.on('click.psm', function (e) {
        if (e.target === this) {
          self.close();
        }
      });
      // ESCで閉じる
      $(document).on('keydown.psm', function (e) {
        if (e.key === 'Escape') {
          self.close();
        }
      });
      // 決定ボタン
      this.$confirm.off('click.psm').on('click.psm', () => {
        const selectedIds = self.getSelectedIds();
        const selectedNames = self.getSelectedNames();
        if (!self.onConfirm) return;
        // loadingOnConfirm=falseは同期処理向け（フィルタ確定など）でローディング表示を出さない
        if (self.loadingOnConfirm) {
          self._setLoading(true);
        }
        self.onConfirm(selectedIds, selectedNames);
      });
      this._bound = true;
    }
  }

  window.PlayerSelectModal = PlayerSelectModal;
})();

